module.exports = __webpack_public_path__ + "img/account-expired-icon.b482a50d.svg";